import { Schema as S } from 'effect'
import { Country } from './country'
import { WowheelNote } from './notes'
import { Varietal } from './varietal'

const requiredMessage = {
  missingMessage: () => 'Dette felt er påkrævet',
}

export const altitudes = ['Below 1000', '1000 - 1500', '1500 - 2000', '2000+'] as const
export const advent24Rounds = ['1', '2', '3', '4', '5', '6'] as const

export class MCLSubmission extends S.Class<MCLSubmission>('MCLSubmission')(S.Struct({
  round: S.propertySignature(S.Literal(...advent24Rounds))
    .annotations(requiredMessage),

  continent: S.propertySignature(S.Literal('africa', 'asia', 'americas', 'oceania'))
    .annotations(requiredMessage),

  country: S.propertySignature(Country)
    .annotations(requiredMessage),

  notes: S.Tuple(...S.Tuple(WowheelNote, WowheelNote).elements, WowheelNote),

  varietal: S.propertySignature(Varietal).annotations(requiredMessage),

  altitude: S.propertySignature(S.Literal(...altitudes))
    .annotations(requiredMessage),

  processing: S.propertySignature(S.Literal('washed', 'honey', 'natural'))
    .annotations(requiredMessage),

  comment: S.optional(S.NullOr(S.String)),
}).annotations({ title: 'MCL Submission' })) {}

export class Advent24Submission extends S.Class<Advent24Submission>('Advent24Submission')(S.Struct({
  id: S.optional(S.Number),
  submission: MCLSubmission,
  user: S.String,
  date: S.optional(S.String),
}).annotations({ title: 'Advent24 Submission' })) {}
